const inputCls = "w-full bg-slate-950/60 border border-slate-800 focus:border-amber-500 rounded px-2 py-1.5 font-mono text-xs text-slate-100 text-right";

export function CorPricingRow({ it, canEdit, val, edit, save }) {
  const cell = (k, placeholder, extra = "", testId) => (
    <input value={val(it, k)} disabled={!canEdit} onChange={(e) => edit(it, k, e.target.value)} onBlur={() => save(it)} placeholder={placeholder} className={inputCls + extra} data-testid={testId} />
  );
  return (
    <tr data-testid={`cor-item-${it.finding_id}`}>
      <td className="font-mono text-slate-500">{it.credit ? "CR" : it.n}</td>
      <td><div className="text-slate-100">{it.title}</div><div className="text-slate-500 font-mono">{it.change_type} · {it.citation}</div></td>
      <td className="text-slate-400">{it.quantities.join(", ") || "—"}</td>
      <td className="w-32">{cell("amount", it.credit ? "credit" : "TBD", "", `cor-amount-${it.finding_id}`)}</td>
      <td className="w-20">{cell("days", it.schedule_impact ? "TBD" : "—", "", `cor-days-${it.finding_id}`)}</td>
      <td className="min-w-[160px]">{cell("estimator_note", "basis, assumptions…", " text-left", `cor-note-${it.finding_id}`)}</td>
    </tr>
  );
}
